import { IOnboardingRepository } from '../../domain/repositories/IOnboardingRepository';
import { OnboardingProgressDTO } from '../dto/OnboardingProgressDTO';
import { OnboardingMapper } from '../mappers/OnboardingMapper';

/**
 * SkipOnboardingUseCase
 * Allows user to skip the entire onboarding
 *
 * Business Logic:
 * - Changes status to 'skipped'
 * - Records skippedAt timestamp
 * - Returns updated progress DTO with hasFinished: true
 */
export class SkipOnboardingUseCase {
  constructor(private readonly repository: IOnboardingRepository) {}

  /**
   * Execute the use case
   *
   * @param userId - UUID of the user
   * @param role - User role ('director' | 'teacher' | 'student')
   * @returns Promise<OnboardingProgressDTO> - Updated progress
   */
  async execute(userId: string, role: string): Promise<OnboardingProgressDTO> {
    const progress = await this.repository.skipOnboarding(userId, role);
    return OnboardingMapper.progressToDTO(progress);
  }
}
